export const roles = Object.freeze({
  ADMIN: 'Administrador',
  MAINTAINER: 'Editor',
  VIEWER: 'Lector'
})
